
import XNumber from 'vux/src/components/x-number/index.vue'

export default {
components: {
XNumber
},
data() {
return {
numberModel:10
}
},

}



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-number.vue